// THE SHARED VOCABULARY, French. See common.de.ts for the rules; the record's own content is
// French, so this catalogue is the one that most often has to agree with the data.
import { registerFr } from './index.js';

registerFr({
  // ── the review verbs (the vocabulary of P1) ──
  'Hold': 'Retenir',
  'Held': 'Retenu',
  'held': 'retenu',
  'Refuse': 'Refuser',
  'Refused': 'Refusé',
  'refused': 'refusé',
  'Amend': 'Amender',
  'Amended': 'Amendé',
  'amended': 'amendé',
  'Undo': 'Annuler',
  'Unheld': 'Non retenu',
  'unheld': 'non retenu',
  'Proposed': 'Proposé',
  'proposed': 'proposé',
  'Confirm': 'Confirmer',
  'Confirmed': 'Confirmé',
  'Retract': 'Retirer',
  'Retracted': 'Retiré',
  'Discharge': 'Solder',
  'Discharged': 'Soldé',
  'Drop': 'Abandonner',
  'Dropped': 'Abandonné',
  'Archive': 'Archiver',
  'Archived': 'Archivé',

  // ── the everyday verbs ──
  'Save': 'Enregistrer',
  'Cancel': 'Annuler',
  'Close': 'Fermer',
  'Delete': 'Supprimer',
  'Edit': 'Modifier',
  'Add': 'Ajouter',
  'New': 'Nouveau',
  'Remove': 'Retirer',
  'Refresh': 'Actualiser',
  'Open': 'Ouvrir',
  'Try again': 'Réessayer',
  'Clear the filter': 'Effacer le filtre',
  'Log out': 'Se déconnecter',
  'Loading…': 'Chargement…',
  'Saving…': 'Enregistrement…',

  // ── the refusal reasons ──
  'duplicate': 'doublon',
  'wrong_evidence': 'preuve erronée',
  'stale': 'périmé',
  'not_relevant': 'non pertinent',
  'out_of_scope': 'hors périmètre',
  'other': 'autre',

  // ── statuses on the record ──
  'active': 'actif',
  'dormant': 'en veille',
  'archived': 'archivé',
  'candidate': 'candidat',
  'current': 'courant',
  'superseded': 'remplacé',
  'open': 'ouvert',
  'discharged': 'soldé',

  // ── the pipeline stages ──
  'lead': 'piste',
  'qualified': 'qualifié',
  'scoping': 'cadrage',
  'proposal': 'offre',
  'negotiation': 'négociation',
  'contracting': 'contractualisation',
  'won': 'gagné',
  'lost': 'perdu',

  // ── the nav ──
  'Overview': 'Vue d’ensemble',
  'Network': 'Réseau',
  'Outreach': 'Approche',
  'System': 'Système',

  // ── the small words ──
  'not collected': 'non relevé',
  'nothing on record': 'rien au dossier',
  'not set': 'non défini',
  'not named': 'non nommé',
  'undated': 'sans date',
  'none': 'aucun',
  'Nothing was written.': 'Rien n’a été écrit.',
  'Could not load': 'Chargement impossible',
  'Nothing matches': 'Aucune correspondance',
  'Nothing here yet': 'Rien ici pour l’instant',
  'Not built yet': 'Pas encore construit',
  'us': 'nous',
  'them': 'eux',
  'late': 'en retard',
  'due': 'échéance',
  'people': 'personnes',
  'person': 'personne',
  'organisation': 'organisation',
  'organisations': 'organisations',
  'deals': 'affaires',
  'Toggle theme': 'Changer le thème',
  'Toggle sidebar': 'Basculer la barre latérale',
  'Open menu': 'Ouvrir le menu',
  'Close menu': 'Fermer le menu',
}, 'common');
